export default __webpack_public_path__ + "static/media/whatsappAudioLoading.84ae510f.gif";